import { createSlice } from "@reduxjs/toolkit";

const initialFormData = {
  applicationId: null,
  mobileNo: "",
  email: "",
  profession: "",
  gstin: "",
  panNumber: "",
  status: "",
  fundRequirement: 0,
  endUseOfFund: "",
  securityOffered: "",
  descriptionOfSecurity: "",
  udyamRegistrationNo: "",
  entityType: "",
  borrowerType: "",
  steps: "",
  totalSalesCurrentYear: 0,
  userId: null,
  estimatedCollateralValue: "",
  authorized: false,
  companyCin: "",
  directorListJson: "",
};

const initialFiles = {
  panCard: [],
  AadharCard: [],
  orderCopy: null,
  contractCopy: null,
  certification: null,
  creditRating: null,
  salarySlips: [],
  joiningLetter: null,

  borrowerPanCard: null,
  moa: null,
  aoa: null,
  listOfDirector: null,
  shareholding: null,
  itr: [],
  balanceSheet: [],
  partnershipDeed: null,
  listOfPatner: null,
  incorporationDateProof: null,
  applicantPan: null,
  applicantAadhar: null,
  coApplicantPan: null,
  coApplicantAadhar: null,
  applicantForm16: null,
  coApplicantForm16: null,
  bankStatement: [],
  slLoan: [],
  gstDocx: null,
  as26: null,
  aadharCard: [],
  applicantItr: [],
  coApplicantItr: [],
};

const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || [],
  loactionFlag: true,
  ip: "",
  cordinates: {},
  tabIndex: 1,
  formData: initialFormData,
  files: initialFiles,
  activeStep: 0,
  notifications: [],
  resumed: false,
  isDocFetched: false,
  queryDialog: {
    isOpen: false,
    activeTab: 0,
    selectedDocuments: [],
    documentComments: {},
    queryText: "",
    lastSubmission: null,
    isSubmitting: false,
    isMessagePage: false,
    selectedProposal: null,
  },
  activeSubTab: "borrower", // Default to
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, { payload }) => {
      state.user = payload || [];
    },
    setLoactionFlag: (state, { payload }) => {
      state.loactionFlag = payload ?? initialState.loactionFlag;
    },
    setIp: (state, { payload }) => {
      state.ip = payload ?? "";
    },
    setCordinates: (state, { payload }) => {
      state.cordinates = payload ?? {};
    },
    setTabIndex: (state, { payload }) => {
      state.tabIndex = payload ?? 1;
    },
    setFormData: (state, { payload }) => {
      state.formData = payload ?? initialFormData;
    },
    updateFormField: (state, { payload }) => {
      const { field, value } = payload;
      state.formData[field] = value;
    },
    setFiles: (state, { payload }) => {
      state.files = payload ?? initialFiles;
    },
    updateFileField: (state, { payload }) => {
      const { field, value } = payload;

      if (field === "panCard") {
        if (
          Object.keys(value).length === 0 ||
          (Array.isArray(value) && value.length === 0)
        ) {
          state.files.panCard = [];
        } else if (Array.isArray(value)) {
          state.files.panCard = value;
        } else {
          if (!Array.isArray(state.files.panCard)) {
            state.files.panCard = [];
          }
          state.files.panCard.push(value);
        }
      } else if (field === "AadharCard" || field === "aadharCard") {
        if (
          Object.keys(value).length === 0 ||
          (Array.isArray(value) && value.length === 0)
        ) {
          state.files.AadharCard = [];
          state.files.aadharCard = [];
        } else if (Array.isArray(value)) {
          state.files.AadharCard = value;
          state.files.aadharCard = value;
        } else {
          if (!Array.isArray(state.files.AadharCard)) {
            state.files.AadharCard = [];
          }
          if (!Array.isArray(state.files.aadharCard)) {
            state.files.aadharCard = [];
          }
          state.files.AadharCard.push(value);
          state.files.aadharCard.push(value);
        }
      } else if (field === "bankStatement") {
        if (
          Object.keys(value).length === 0 ||
          (Array.isArray(value) && value.length === 0)
        ) {
          state.files.bankStatement = [];
        } else if (Array.isArray(value)) {
          state.files.bankStatement = value;
        } else {
          if (!Array.isArray(state.files.bankStatement)) {
            state.files.bankStatement = [];
          }
          const found = state.files.bankStatement.some(
            (f) => f && value && f.filename === value.filename
          );
          if (!found) {
            state.files.bankStatement = [
              ...state.files.bankStatement,
              value,
            ].filter(Boolean);
          }
        }
      } else if (field === "slLoan") {
        if (
          Object.keys(value).length === 0 ||
          (Array.isArray(value) && value.length === 0)
        ) {
          state.files.slLoan = [];
        } else if (Array.isArray(value)) {
          state.files.slLoan = value;
        } else {
          if (!Array.isArray(state.files.slLoan)) {
            state.files.slLoan = [];
          }
          const found = state.files.slLoan.some(
            (f) => f && value && f.filename === value.filename
          );
          if (!found) {
            state.files.slLoan = [...state.files.slLoan, value].filter(Boolean);
          }
        }
      } else if (
        field.startsWith("bankStatement") &&
        field !== "bankStatement"
      ) {
        const index = parseInt(field.replace("bankStatement", "")) - 1;
        if (!Array.isArray(state.files.bankStatement)) {
          state.files.bankStatement = [];
        }
        while (state.files.bankStatement.length <= index) {
          state.files.bankStatement.push(null);
        }
        state.files.bankStatement[index] = value;
      } else if (field.startsWith("slLoan") && field !== "slLoan") {
        const index = parseInt(field.replace("slLoan", "")) - 1;
        if (!Array.isArray(state.files.slLoan)) {
          state.files.slLoan = [];
        }
        while (state.files.slLoan.length <= index) {
          state.files.slLoan.push(null);
        }
        state.files.slLoan[index] = value;
      } else if (
        field === "applicantItr" ||
        field === "coApplicantItr" ||
        field === "itr" ||
        field === "balanceSheet" ||
        field === "salarySlips"
      ) {
        state.files[field] = value;
      } else {
        state.files[field] = value;
      }
    },
    setActiveStep: (state, { payload }) => {
      state.activeStep = payload ?? 0;
    },
    setNotiFications: (state, { payload }) => {
      state.notifications = payload ?? [];
    },
    setResumed: (state, { payload }) => {
      state.resumed = payload ?? false;
    },
    setIsDocFetched: (state, { payload }) => {
      state.isDocFetched = payload ?? false;
    },
    openQueryDialog: (state) => {
      state.queryDialog.isOpen = true;
    },
    closeQueryDialog: (state) => {
      state.queryDialog.isOpen = false;
    },
    setQueryDialogTab: (state, action) => {
      state.queryDialog.activeTab = action.payload;
    },
    toggleQueryDocument: (state, action) => {
      const documentId = action.payload;
      const isSelected =
        state.queryDialog.selectedDocuments.includes(documentId);

      if (isSelected) {
        state.queryDialog.selectedDocuments =
          state.queryDialog.selectedDocuments.filter((id) => id !== documentId);
        delete state.queryDialog.documentComments[documentId];
      } else {
        state.queryDialog.selectedDocuments.push(documentId);
        state.queryDialog.documentComments[documentId] = "";
      }
    },
    updateQueryComment: (state, action) => {
      const { documentId, comment } = action.payload;
      state.queryDialog.documentComments[documentId] = comment;
    },
    setQueryText: (state, action) => {
      state.queryDialog.queryText = action.payload;
    },
    setQuerySubmitting: (state, action) => {
      state.queryDialog.isSubmitting = action.payload;
    },
    resetQueryDialog: (state) => {
      const lastSubmission = state.queryDialog.lastSubmission;
      state.queryDialog = { ...initialState.queryDialog, lastSubmission };
    },
    setQueryMessagePage: (state, action) => {
      state.queryDialog.isMessagePage = action.payload;
    },
    setQuerySelectedProposal: (state, action) => {
      state.queryDialog.selectedProposal = action.payload;
    },
    setActiveSubTab: (state, { payload }) => {
      state.activeSubTab = payload ?? "borrower"; // Default to "borrower"
    },
  },
});

export const {
  setUser,
  setLoactionFlag,
  setIp,
  setCordinates,
  setTabIndex,
  setFormData,
  updateFormField,
  setFiles,
  updateFileField,
  setActiveStep,
  setNotiFications,
  setResumed,
  setIsDocFetched,
  openQueryDialog,
  closeQueryDialog,
  setQueryDialogTab,
  toggleQueryDocument,
  updateQueryComment,
  setQueryText,
  setQuerySubmitting,
  resetQueryDialog,
  setQueryMessagePage,
  setQuerySelectedProposal,
  setActiveSubTab,
} = userSlice.actions;

export const selectFormData = (state) => state.user.formData;
export const selectFiles = (state) => state.user.files;
export const activeSteps = (state) => state.user.activeStep;
export const notifications = (state) => state.user.notifications;
export const resume = (state) => state.user.resumed;
export const isDocFetched = (state) => state.user.isDocFetched;
export const user = (state) => state.user.user;
export const selectQueryDialog = (state) => state.user.queryDialog;
export const selectQueryDialogIsOpen = (state) => state.user.queryDialog.isOpen;
export const selectQueryDialogActiveTab = (state) =>
  state.user.queryDialog.activeTab;
export const selectQueryDialogSelectedDocuments = (state) =>
  state.user.queryDialog.selectedDocuments;
export const selectQueryDialogDocumentComments = (state) =>
  state.user.queryDialog.documentComments;
export const selectQueryDialogText = (state) =>
  state.user.queryDialog.queryText;
export const selectQueryDialogIsSubmitting = (state) =>
  state.user.queryDialog.isSubmitting;
export const selectQueryDialogIsMessagePage = (state) =>
  state.user.queryDialog.isMessagePage;
export const selectQueryDialogSelectedProposal = (state) =>
  state.user.queryDialog.selectedProposal;
export const activeSubTab = (state) => state.user.activeSubTab;

export default userSlice.reducer;
